import { getFullNameErrorPayLoad, getFullNameSuccessPayLoad, getTicketByUserIdErrorPayLoad, getTicketByUserIdSuccessPayLoad, GetTicketErrorPayLoad, GetTicketSuccessPayload, registerTicketErrorPayLoad, registerTicketRequestPayLoad, replyTicketErrorPayLoad, replyTicketRequestPayLoad, replyTicketSuccessPayLoad } from "../interfaces/ticket";
import { Types } from "../types";
import { getFullNameError, getFullNameRequest, getFullNameSuccess, getTicketByUserIdError, getTicketByUserIdRequest, getTicketByUserIdSuccess, getTicketError, getTicketRequest, getTicketSuccess, registerTicketError, registerTicketRequest, registerTicketSuccess, replyTicketError, replyTicketRequest, replyTicketSuccess, resetTicketRegisterRequest } from "../types/ticket/actionTypes";





export const getTicketRequestAction = (): getTicketRequest => ({
    type: Types.GET_TICKET_BY_USER_REQUEST,
})
export const getTicketSuccessAction = (payload: GetTicketSuccessPayload): getTicketSuccess => ({
    type: Types.GET_TICKET_BY_USER_SUCCESS,
    payload
})
export const getTicketErrorAction = (payload: GetTicketErrorPayLoad): getTicketError => ({
    type: Types.GET_TICKET_BY_USER_ERROR,
    payload
})

export const resetTicketRegisterAction = ():resetTicketRegisterRequest=> ({
    type: Types.RESET_TICKET_REGISTER,
})

//************************************************************************************************************** */
export const registerTicketRequestAction = (payload: registerTicketRequestPayLoad): registerTicketRequest => ({
    type: Types.REGISTER_TICKET_REQUEST,
    payload
})
export const registerTicketSuccessAction = (): registerTicketSuccess => ({
    type: Types.REGISTER_TICKET_SUCCESS,
})
export const registerTicketErrorAction = (payload: registerTicketErrorPayLoad): registerTicketError => ({
    type: Types.REGISTER_TICKET_ERROR,
    payload
})
//**************************************************************************************************************** */
export const getTicketByUserIdRequestAction = (payload: string): getTicketByUserIdRequest => ({
    type: Types.GET_TICKET_BY_USER_ID_TICKET_REQUEST,
    payload
})
export const getTicketByUserIdSuccessAction = (payload: getTicketByUserIdSuccessPayLoad): getTicketByUserIdSuccess => ({
    type: Types.GET_TICKET_BY_USER_ID_TICKET_SUCCESS,
    payload
})
export const getTicketByUserIdErrorAction = (payload: getTicketByUserIdErrorPayLoad): getTicketByUserIdError => ({
    type: Types.GET_TICKET_BY_USER_ID_TICKET_ERROR,
    payload
})
//***************************************************************************************************************** */
export const replyTicketRequestAction = (payload: replyTicketRequestPayLoad): replyTicketRequest => ({
    type: Types.REPLY_TICKET_REQUEST,
    payload
})
export const replyTicketSuccessAction = (payload: replyTicketSuccessPayLoad): replyTicketSuccess => ({
    type: Types.REPLY_TICKET_SUCCESS,
    payload
})
export const replyTicketErrorAction = (payload: replyTicketErrorPayLoad): replyTicketError => ({
    type: Types.REPLY_TICKET_ERROR,
    payload
})
//******************************************************************************************************************** */

export const getFullNameRequestAction = (): getFullNameRequest => ({
    type: Types.GET_FULL_NAME_REQUEST,
})
export const getFullNameSuccessAction = (payload: getFullNameSuccessPayLoad): getFullNameSuccess => ({
    type: Types.GET_FULL_NAME_SUCCESS,
    payload
})
export const getFullNameErrorAction = (payload: getFullNameErrorPayLoad): getFullNameError => ({
    type: Types.GET_FULL_NAME_ERROR,
    payload
})